import { SinatraState } from '@rsos/sinatra';
import { IncidentsState } from '../alerts/incidentsSlice';
import { PsapState } from '../capstone/psapInfo/psapInfoSlice';
import { conversationStateValues } from '../conversations/conversations.typings';
import { EmergencyCallsState } from '../emergencyCalls/emergencyCallsSlice';
import { EventPaneState } from '../eventPane/eventPaneSlice';
import { RCSState } from '../rcs/rcsSlice';
import { TextFrom911State } from '../textFrom911/textFrom911Slice';

export type AudioNotificationStatus = {
  repeatsRemaining: number;
  /* A datestamp: */
  expiration?: number | null;
};

export const NOTIFICATION_COMPLETE = (): AudioNotificationStatus => ({
  repeatsRemaining: 0,
});

export type AudioNotificationsState = {
  /* key is an alertID: */
  alerts: Record<string, AudioNotificationStatus>;
  /* key is a callerID: */
  calls: Record<string, AudioNotificationStatus>;
  /* key is caller.messageID */
  textMessages: Record<string, AudioNotificationStatus>;
  /* key is alertID.messageID */
  alertMessages: Record<string, AudioNotificationStatus>;
  suppressedAudio: string;
};

export type AudioNotificationStatusCategories = Exclude<
  keyof AudioNotificationsState,
  'suppressedAudio'
>;

export interface AudioNotificationsGlobalState {
  psaps: PsapState;
  sinatra: SinatraState;
  emergencyCalls: EmergencyCallsState;
  audioNotifications: AudioNotificationsState;
  textFrom911: TextFrom911State;
  incidents: IncidentsState;
  rcs: RCSState;
  eventPane: EventPaneState;
  conversations: Record<string, conversationStateValues>;
}
